import { motion } from "framer-motion";

import HandwrittenText from "../../HandwrittenText";
import { useState } from "react";
import PopupNewsletter from "../pages/PopupNewsletter";


export default function GallerySection() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const message = '¿Te apasiona la fantasía, la estética de mundos literarios y los eventos mágicos? En Eryndra buscamos hadas creativas, marujas soñadoras y artesanas de experiencias. Si sientes que este mundo te llama… es hora de responder.';

  return (
    <motion.section
      id="galeria"
      className="bg-eryndra-forest py-20 px-6 text-center flex justify-center"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >

<div className="relative bg-[url('/public/img/pergamino-textura.png')] bg-cover bg-center  font-bellefair max-w-3xl w-full md:p-10 p-3 shadow-[0_0_30px_rgba(211,185,124,0.4)] border-2 border-eryndra-gold">
    
    <h2 className="text-3xl md:text-4xl font-title text-eryndra-forest mb-6 tracking-wider">ÚNeTe A eRYNDRA
    </h2>
    
    {/* <p className=" text-black text-lg md:text-xl leading-relaxed mb-16">
      ¿Te apasiona la fantasía, la estética de mundos literarios y los eventos mágicos? En Eryndra buscamos hadas creativas, marujas soñadoras y artesanas de experiencias. Si sientes que este mundo te llama… es hora de responder.
    </p> */}
    <div className="mb-12 sm:p-2">
      <HandwrittenText text={message} delay={0.02} />
    </div>
    

    {/* Sello interactivo */}
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        setIsPopupOpen(true);
      }}
      className="absolute bottom-[-2rem] size-back-sello left-1/2 transform -translate-x-1/2 w-24 h-24 bg-[url('/public/img/sello-eryndra.png')] bg-cover bg-center rounded-full border-4 border-eryndra-gold shadow-lg hover:scale-110 transition-transform duration-300"
      aria-label="Unirse al equipo"
    ></a>
  </div>
      {/* <h2 className="text-3xl font-bold mb-8">Únete a Eryndra</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <img src="img/gallery1.png" alt="Inspiración 1" className="rounded-lg h-48 object-cover w-full" />
        <img src="img/gallery2.jpg" alt="Inspiración 2" className="rounded-lg h-48 object-cover w-full" />
        <img src="img/gallery3.jpg" alt="Inspiración 3" className="rounded-lg h-48 object-cover w-full" />
      </div> */}
      <PopupNewsletter isOpen={isPopupOpen} setIsOpen={setIsPopupOpen} />
    </motion.section>
    

  );
}